<template>
    <v-container class="py-0">
        <div>
            <div class="title title-blue">
                <TranslatableStringComponent
                    :tstring="{ string: 'selectedSamples' }"
                />:
            </div>
            <div v-for="item in 3" :key="item">
                <v-text-field
                    :key="selectedSampleKey"
                    :id="`Sample${item}`"
                    :label="`Sample ${item}`"
                    outlined
                    :readonly="true"
                    dense
                    clearable
                    placeholder=" "
                    :value="getOptionName(item - 1)"
                    @click:clear="removeOptionName(item - 1)"
                ></v-text-field>
            </div>
        </div>
        <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
            <v-form
                id="sampleRequestForm"
                ref="sampleRequestForm"
                data-netlify="true"
                data-netlify-honeypot="bot-field"
                name="sampleRequestForm"
                action="/samples/"
                method="POST"
                @submit.prevent="handleSubmit(handleSubmission)"
            >
                <input
                    id="form-name"
                    type="hidden"
                    name="form-name"
                    value="sampleRequestForm"
                />
                <v-container class="pa-0 mb-10">
                    <div class="title mb-0 title-blue">
                        <TranslatableStringComponent
                            :tstring="{ string: 'contactInformation' }"
                        />:
                    </div>
                    <v-row column justify-center align-center>
                        <v-col cols="12" md="6">
                            <ValidationProvider
                                name="firstname"
                                rules="required"
                                class="validationWrapper"
                            >
                                <div slot-scope="{ errors }">
                                    <span class="validationMessage">{{
                                        errors[0]
                                    }}</span>
                                    <v-text-field
                                        id="firstname"
                                        v-model="firstname"
                                        name="firstname"
                                        :label="localize('firstName')"
                                        outlined
                                        dense
                                        :hide-details="true"
                                    ></v-text-field>
                                </div>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" md="6">
                            <ValidationProvider
                                name="lastname"
                                rules="required"
                                class="validationWrapper"
                            >
                                <div slot-scope="{ errors }">
                                    <span class="validationMessage">{{
                                        errors[0]
                                    }}</span>
                                    <v-text-field
                                        id="lastname"
                                        v-model="lastname"
                                        name="lastname"
                                        :label="localize('lastName')"
                                        outlined
                                        dense
                                        :hide-details="true"
                                    ></v-text-field>
                                </div>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" md="6">
                            <ValidationProvider
                                name="email"
                                rules="required|email|emoji"
                                class="validationWrapper"
                            >
                                <div slot-scope="{ errors }">
                                    <span class="validationMessage">{{
                                        errors[0]
                                    }}</span>
                                    <v-text-field
                                        id="email"
                                        v-model="email"
                                        name="email"
                                        :label="localize('email')"
                                        outlined
                                        dense
                                        :hide-details="true"
                                    ></v-text-field>
                                </div>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" md="6">
                            <ValidationProvider
                                name="phone"
                                rules="required"
                                class="validationWrapper"
                            >
                                <div slot-scope="{ errors }">
                                    <span class="validationMessage">{{
                                        errors[0]
                                    }}</span>
                                    <v-text-field
                                        id="phone"
                                        v-model="phone"
                                        v-mask="phoneMask"
                                        name="phone"
                                        :label="localize('phone')"
                                        outlined
                                        dense
                                        :hide-details="true"
                                    ></v-text-field>
                                </div>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" md="12">
                            <ValidationProvider
                                name="jobtitle"
                                rules="required"
                                class="validationWrapper"
                            >
                                <div slot-scope="{ errors }">
                                    <span class="validationMessage">{{
                                        errors[0]
                                    }}</span>
                                    <v-text-field
                                        id="jobtitle"
                                        v-model="jobtitle"
                                        name="jobtitle"
                                        :label="localize('jobTitle')"
                                        outlined
                                        dense
                                        :hide-details="true"
                                    ></v-text-field>
                                </div>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" md="12">
                            <ValidationProvider
                                name="hs_persona"
                                rules="required"
                                class="validationWrapper"
                            >
                                <div slot-scope="{ errors }">
                                    <span class="validationMessage">{{
                                        errors[0]
                                    }}</span>
                                    <v-select
                                        id="hs_persona"
                                        v-model="hs_persona"
                                        :items="jobRoleOptions"
                                        name="hs_persona"
                                        item-text="label"
                                        item-value="value"
                                        outlined
                                        dense
                                        :hide-details="true"
                                        :label="localize('whatIsYourRole')"
                                    ></v-select>
                                </div>
                            </ValidationProvider>
                        </v-col>
                    </v-row>
                </v-container>
                <v-container class="pa-0 mb-10">
                    <div class="title mb-0 title-blue">
                        <TranslatableStringComponent
                            :tstring="{ string: 'companyInformation' }"
                        />:
                    </div>
                    <v-row column justify-center align-center>
                        <v-col cols="12" md="12">
                            <ValidationProvider
                                name="company"
                                rules="required"
                                class="validationWrapper"
                            >
                                <div slot-scope="{ errors }">
                                    <span class="validationMessage">{{
                                        errors[0]
                                    }}</span>
                                    <v-text-field
                                        id="company"
                                        v-model="company"
                                        name="company"
                                        :label="localize('company')"
                                        outlined
                                        dense
                                        :hide-details="true"
                                    ></v-text-field>
                                </div>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" md="12">
                            <ValidationProvider
                                name="business_focus_up"
                                rules="required"
                                class="validationWrapper"
                            >
                                <div slot-scope="{ errors }">
                                    <span class="validationMessage">{{
                                        errors[0]
                                    }}</span>
                                    <v-select
                                        id="business_focus_up"
                                        v-model="business_focus_up"
                                        :items="businessFocusOptions"
                                        name="business_focus_up"
                                        item-text="label"
                                        item-value="value"
                                        outlined
                                        dense
                                        :hide-details="true"
                                        :label="
                                            localize(
                                                'whatSTheFocusOfYourBusiness'
                                            )
                                        "
                                    ></v-select>
                                </div>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" md="12">
                            <ValidationProvider
                                name="spec_point_person_up"
                                rules="required"
                                class="validationWrapper"
                            >
                                <div slot-scope="{ errors }">
                                    <span class="validationMessage">{{
                                        errors[0]
                                    }}</span>
                                    <v-select
                                        id="spec_point_person_up"
                                        v-model="spec_point_person_up"
                                        :items="controlSpecificationOptions"
                                        name="spec_point_person_up"
                                        item-text="label"
                                        item-value="value"
                                        outlined
                                        dense
                                        :hide-details="true"
                                        :label="
                                            localize(
                                                'companyControlTheSpecification'
                                            )
                                        "
                                    ></v-select>
                                </div>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" md="12">
                            <ValidationProvider
                                name="primary_electrical_controls_supplier_up"
                                rules="required"
                                class="validationWrapper"
                            >
                                <div slot-scope="{ errors }">
                                    <span class="validationMessage">{{
                                        errors[0]
                                    }}</span>
                                    <v-select
                                        id="primary_electrical_controls_supplier_up"
                                        v-model="
                                            primary_electrical_controls_supplier_up
                                        "
                                        :items="primarySupplierOptions"
                                        name="primary_electrical_controls_supplier_up"
                                        item-text="label"
                                        item-value="value"
                                        outlined
                                        dense
                                        :hide-details="true"
                                        :label="
                                            localize(
                                                'primaryElectricalControlsSupplier'
                                            )
                                        "
                                    ></v-select>
                                </div>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" md="12">
                            <ValidationProvider
                                name="annual_electrical_controls_spend_up"
                                rules="required"
                                class="validationWrapper"
                            >
                                <div slot-scope="{ errors }">
                                    <span class="validationMessage">{{
                                        errors[0]
                                    }}</span>
                                    <v-select
                                        id="annual_electrical_controls_spend_up"
                                        v-model="
                                            annual_electrical_controls_spend_up
                                        "
                                        :items="
                                            companyElectricalExpenditureOptions
                                        "
                                        name="annual_electrical_controls_spend_up"
                                        item-text="label"
                                        item-value="value"
                                        outlined
                                        dense
                                        :hide-details="true"
                                        :label="
                                            localize(
                                                'annualExpenseElectricalProducts'
                                            )
                                        "
                                    ></v-select>
                                </div>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" md="12">
                            <ValidationProvider
                                name="numemployees"
                                rules="required"
                                class="validationWrapper"
                            >
                                <div slot-scope="{ errors }">
                                    <span class="validationMessage">{{
                                        errors[0]
                                    }}</span>
                                    <v-select
                                        id="numemployees"
                                        v-model="numemployees"
                                        :items="employeesOptions"
                                        name="numemployees"
                                        item-text="label"
                                        item-value="value"
                                        outlined
                                        dense
                                        :hide-details="true"
                                        :label="localize('numberOfEmployees')"
                                    ></v-select>
                                </div>
                            </ValidationProvider>
                        </v-col>
                    </v-row>
                </v-container>
                <v-container class="pa-0">
                    <div class="title mb-0 title-blue">
                        <TranslatableStringComponent
                            :tstring="{ string: 'mailingInformation' }"
                        />:
                    </div>
                    <v-row column justify-center align-center>
                        <v-col cols="12" md="12">
                            <ValidationProvider
                                name="country"
                                rules="required"
                                class="validationWrapper"
                            >
                                <div slot-scope="{ errors }">
                                    <span class="validationMessage">{{
                                        errors[0]
                                    }}</span>
                                    <v-select
                                        id="country"
                                        v-model="country"
                                        :items="countries"
                                        name="country"
                                        item-text="name"
                                        item-value="name"
                                        :disabled="true"
                                        :label="localize('country')"
                                        outlined
                                        dense
                                        :hide-details="true"
                                        @change="clearFields()"
                                    >
                                        <!-- <option disabled value=""
                                                                >Please select one</option
                                                    >-->
                                        <template
                                            slot="selection"
                                            slot-scope="data"
                                        >
                                            <!-- HTML CAN WRAP THIS -->
                                            {{ data.item.name }}
                                        </template>
                                        <template slot="item" slot-scope="data">
                                            <!-- HTML CAN WRAP THIS -->
                                            {{ data.item.name }}
                                        </template>
                                    </v-select>
                                </div>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" md="12">
                            <ValidationProvider
                                name="address"
                                rules="required"
                                class="validationWrapper"
                            >
                                <div slot-scope="{ errors }">
                                    <span class="validationMessage">{{
                                        errors[0]
                                    }}</span>
                                    <v-text-field
                                        id="address"
                                        v-model="address"
                                        name="address"
                                        :label="localize('address')"
                                        outlined
                                        dense
                                        :hide-details="true"
                                    ></v-text-field>
                                </div>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" md="12">
                            <ValidationProvider
                                name="street_address_2"
                                class="validationWrapper"
                            >
                                <div slot-scope="{ errors }">
                                    <span class="validationMessage">{{
                                        errors[0]
                                    }}</span>
                                    <v-text-field
                                        id="street_address_2"
                                        v-model="street_address_2"
                                        name="street_address_2"
                                        :label="
                                            localize('addressLine2Optional')
                                        "
                                        outlined
                                        dense
                                        :hide-details="true"
                                    ></v-text-field>
                                </div>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" md="12">
                            <ValidationProvider
                                name="city"
                                rules="required"
                                class="validationWrapper"
                            >
                                <div slot-scope="{ errors }">
                                    <span class="validationMessage">{{
                                        errors[0]
                                    }}</span>
                                    <v-text-field
                                        id="city"
                                        v-model="city"
                                        name="city"
                                        :label="localize('cityTown')"
                                        outlined
                                        dense
                                        :hide-details="true"
                                    ></v-text-field>
                                </div>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" md="6">
                            <ValidationProvider
                                name="state"
                                rules="required"
                                class="validationWrapper"
                            >
                                <div slot-scope="{ errors }">
                                    <span class="validationMessage">{{
                                        errors[0]
                                    }}</span>
                                    <v-select
                                        v-show="
                                            country === 'United States' ||
                                            country === 'Canada'
                                        "
                                        id="state"
                                        v-model="state"
                                        :items="
                                            country === 'United States'
                                                ? statesUS
                                                : provincesCanada
                                        "
                                        name="state"
                                        item-text="name"
                                        item-value="name"
                                        :label="localize('stateProvince')"
                                        outlined
                                        dense
                                        :hide-details="true"
                                    >
                                        <!-- <option disabled value=""
                                                                >Please select one</option
                                                    >-->
                                        <template
                                            slot="selection"
                                            slot-scope="data"
                                        >
                                            <!-- HTML CAN WRAP THIS -->
                                            {{ data.item.name }}
                                        </template>
                                        <template slot="item" slot-scope="data">
                                            <!-- HTML CAN WRAP THIS -->
                                            {{ data.item.name }}
                                        </template>
                                    </v-select>
                                    <v-text-field
                                        v-show="
                                            country !== 'United States' &&
                                            country !== 'Canada'
                                        "
                                        id="state"
                                        v-model="state"
                                        name="state"
                                        :label="localize('stateProvince')"
                                        outlined
                                        dense
                                        :hide-details="true"
                                    ></v-text-field>
                                </div>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" md="6">
                            <ValidationProvider
                                name="zip"
                                :rules="zipcodeValidationRule"
                                class="validationWrapper"
                            >
                                <div slot-scope="{ errors }">
                                    <span class="validationMessage">{{
                                        errors[0]
                                    }}</span>
                                    <v-text-field
                                        id="zip"
                                        v-model="zip"
                                        name="zip"
                                        :label="localize('zipPostalCode')"
                                        outlined
                                        dense
                                        :hide-details="true"
                                    ></v-text-field>
                                </div>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" style="height: 95px">
                            <recaptcha
                                @success="onSuccess"
                                @error="onError"
                                @expired="onExpired"
                            />
                            <div v-if="captchaError" class="captcha-error">
                                <TranslatableStringComponent
                                    :tstring="{ string: 'captchaRequired' }"
                                />
                            </div>
                        </v-col>
                        <v-col>
                            <v-btn
                                type="submit"
                                color="primary"
                                right
                                :loading="loader"
                                @click="scrollIntoView()"
                                ><TranslatableStringComponent
                                    :tstring="{ string: 'requestSamples' }"
                            /></v-btn>
                        </v-col>
                        <v-col cols="12">
                            <v-alert
                                v-if="samplesNotSelected"
                                color="primary"
                                text
                                dense
                                border="left"
                                class="red--text"
                            >
                                <TranslatableStringComponent
                                    :tstring="{ string: 'selectSamples' }"
                                />
                            </v-alert>
                            <v-alert
                                v-if="sending"
                                color="primary"
                                dense
                                text
                                border="left"
                            >
                                <TranslatableStringComponent
                                    :tstring="{
                                        string: 'submittingContactForm',
                                    }"
                                />
                            </v-alert>
                            <v-alert
                                v-if="waiting"
                                color="primary"
                                dense
                                text
                                border="left"
                            >
                                <TranslatableStringComponent
                                    :tstring="{ string: 'awaitingContactForm' }"
                                />
                            </v-alert>
                            <v-alert
                                v-model="success"
                                dense
                                dark
                                border="left"
                                color="primary"
                                style="text-align: center"
                                dismissible
                            >
                                <TranslatableBlockComponent
                                    :tstring="{
                                        string: 'successSampleRequestForm',
                                    }"
                                    :includeClass="true"
                                />
                            </v-alert>
                            <v-alert
                                v-if="failure"
                                type="error"
                                dense
                                text
                                border="left"
                            >
                                <TranslatableStringComponent
                                    :tstring="{ string: 'failedContactForm' }"
                                />
                            </v-alert>
                        </v-col>
                    </v-row>
                </v-container>
            </v-form>
        </ValidationObserver>
    </v-container>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { createHelpers } from 'vuex-map-fields'
import { mapGetters, mapState } from 'vuex'
import { mask } from 'vue-the-mask'
import Cookies from 'js-cookie'
import { gtmEvent } from '~/plugins/global'
import handleRecaptcha from '~/mixins/handleRecaptcha'
import handleSnackbar from '~/mixins/handleSnackbar'
import encodeFormData from '~/mixins/encodeFormData'
import scrollIntoView from '~/mixins/scrollIntoView'
import countries from '~/util/arrays/countries.js'
import statesUS from '~/util/statesUS.js'
import provincesCanada from '~/util/arrays/provincesCanada.js'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue'
import TranslatableBlockComponent from '~/components/TranslatableBlockComponent.vue'
const { mapFields } = createHelpers({
    getterType: 'getSampleRequestField',
    mutationType: 'updateSampleRequestField',
})

export default {
    name: 'FormSampleRequest',
    components: {
        ValidationProvider,
        ValidationObserver,
        TranslatableStringComponent,
        TranslatableBlockComponent,
    },
    directives: {
        mask,
    },
    mixins: [encodeFormData, handleRecaptcha, handleSnackbar, scrollIntoView],
    data() {
        return {
            hints: {
                email: '',
                password: '',
            },
            sending: false,
            waiting: false,
            success: false,
            failure: false,
            loader: false,
            samplesNotSelected: false,
            phoneMask: '(###) ###-####',
            countries,
            statesUS,
            selectedSampleKey: 0,
            provincesCanada,
        }
    },
    computed: {
        ...mapGetters({
            selectedSampleProducts:
                'sampleReferenceTable/selectedSampleProducts',
        }),
        ...mapState('sampleReferenceTable', ['selectedSamples']),
        ...mapState('formSelectOptions', [
            'jobRoleOptions',
            'businessFocusOptions',
            'controlSpecificationOptions',
            'primarySupplierOptions',
            'companyElectricalExpenditureOptions',
            'employeesOptions',
        ]),
        ...mapFields('sampleRequest', [
            'firstname',
            'lastname',
            'email',
            'phone',
            'jobtitle',
            'hs_persona',
            'company',
            'business_focus_up',
            'spec_point_person_up',
            'primary_electrical_controls_supplier_up',
            'annual_electrical_controls_spend_up',
            'numemployees',
            'country',
            'address',
            'street_address_2',
            'city',
            'state',
            'zip',
        ]),
        selectedSampleProductsNames() {
            return this.selectedSampleProducts.map((item) => item.title.en)
        },
        zipcodeValidationRule() {
            return this.country === 'United States'
                ? 'required|digits:5'
                : 'required'
        },
    },
    watch: {
        selectedSamples(newVal) {
            if (newVal.length > 0) this.success = false
        },
    },
    methods: {
        handleSubmission() {
            if (!this.token) {
                this.captchaError = true
                return
            }
            if (this.selectedSamples.length === 0) {
                this.samplesNotSelected = true
                return
            } else {
                this.samplesNotSelected = false
            }
            this.sending = true
            this.waiting = false
            this.success = false
            this.failure = false
            this.loader = true
            const hubspotutk = Cookies.get('hubspotutk') || 0
            const axiosConfig = {
                header: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            }

            this.$axios
                .post('reCaptcha-server-side-validation', {
                    token: this.token,
                })
                .then((res) => {
                    // console.log('RECAPTCHA RESPONSE:', res)
                    if (res.data && res.data.success === false) throw res.data
                    this.$axios
                        .post(
                            process.env.V2_BASE_URL + '/samples/',
                            this.encode({
                                'form-name': 'sampleRequestForm',
                                // 'name.first': this.firstname,
                                // 'name.last': this.lastname,
                                // email: this.email,
                                // 'PhoneNumber.number': this.phone,
                                // 'customData.jobTitle': this.jobtitle,
                                // 'customData.persona': this.hs_persona,
                                // 'name.company': this.company,
                                // 'customData.companyFocus': this
                                //     .business_focus_up,
                                // 'customData.companyControlsOwnSpec': this
                                //     .spec_point_person_up,
                                // 'customData.companyPrimarySupplier': this
                                //     .primary_electrical_controls_supplier_up,
                                // 'customData.companyAnnualSpend': this
                                //     .annual_electrical_controls_spend_up,
                                // 'customData.companyNumberOfEmployees': this
                                //     .numemployees,
                                // 'MailAddress.country': this.country,
                                // 'MailAddress.line1': this.address,
                                // 'MailAddress.line2': this.street_address_2,
                                // 'MailAddress.city': this.city,
                                // 'MailAddress.state': this.state,
                                // 'MailAddress.postalCode': this.zip,
                                // 'customData.lastSamplesRequested': this.selectedSampleProductsNames.join(),
                                ...this.$store.state.sampleRequest
                                    .sampleRequestForm,
                                samples_requested: this.selectedSampleProductsNames.join(),
                                hubspotutk,
                            }),
                            axiosConfig
                        )
                        .then((res) => {
                            // console.log('full response', res)
                            this.sending = false
                            this.waiting = true
                            this.$axios
                                .post(
                                    'submitted-web-form',
                                    res.config.data,
                                    axiosConfig
                                )
                                .then((response) => {
                                    // console.log('lambda response was', response)
                                    gtmEvent({
                                        gtm: this.$gtm,
                                        event: 'sampleRequestForm',
                                        eventType: 'form',
                                        atts: {
                                            ...this.$store.state.sampleRequest
                                                .sampleRequestForm,
                                        },
                                    })
                                    this.resetForm('sampleRequestForm')
                                    this.$recaptcha.reset()
                                    // console.log(
                                    //     'This was a success on the frontend'
                                    // )
                                    this.loader = false
                                    this.waiting = false
                                    this.success = true
                                    setTimeout(() => {
                                        this.country = 'United States'
                                    }, 500)
                                    this.$store.commit(
                                        'sampleReferenceTable/clearSamples'
                                    )
                                })
                                .catch((error) => {
                                    console.log('lambda failure was', error)
                                    this.handleErrors()
                                })
                        })
                        .catch((err) => {
                            console.log(
                                'This order submission failed at Netify for some reason. Please try again. ERROR:',
                                err
                            )
                            this.handleErrors()
                        })
                })
                .catch((err) => {
                    const errorMessage = 'recaptchaFailedMessage'
                    console.log(errorMessage, err)
                    this.handleErrors(errorMessage)
                })
        },

        getOptionName(index) {
            return this.selectedSamples[index]
                ? `${this.selectedSamples[index].categories[0].label.en} : ${this.selectedSamples[index].title.en}`
                : ''
        },
        removeOptionName(index) {
            var categoryId = this.selectedSamples[index].categories[0]._id
            this.$store.dispatch(
                'sampleReferenceTable/addSample',
                this.selectedSamples[index]
            )
            this.$store.commit(
                'sampleReferenceTable/removeSelectedCategory',
                categoryId
            )
            this.selectedSampleKey++
        },
        handleErrors(errorMessage) {
            this.$recaptcha.reset()
            this.loader = false
            this.sending = false
            this.waiting = false
            this.failure = true
            this.hitSnackbar({ string: errorMessage }, {})
        },
        clearFields() {
            this.$store.commit('sampleRequest/clearFields')
        },
    },
}
</script>
